<template>
    <div class="sport-subnav">
        <div
            v-if="isSidebarExpanded || isTimeFilterExpanded"
            class="modal__overlay"
            @click="hideOverlay"
        >
        </div>
        <PrimaryNavItem
            @click="handleClick(selectedItem)"
            :selectedItem="selectedItem"
            :isSidebarExpanded="isSidebarExpanded"
        />
        <button
            class="mobile-subnav__item mobile-subnav__item--secondary"
            @click="toggleTimeFilter"
        >
            <div class="flex__align-center">
                <i class="icon--md icon-events mr-2"/>
                <span class="mobile-subnav__item-text">
                    {{ important }}
                </span>
            </div>
        </button>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { timeFilterMixing } from '@app/modules/shared/timeFilter/mixins/timeFilter';
    import { ExpandedEventInUrl } from '@app/enums';
    import { getSportNavItem } from '@app/mobile/helpers/navigation';
    import PrimaryNavItem from '@app/mobile/components/PrimaryNavItem';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';
    import { TimeFilter } from '@shared/timeFilter/enums';
    import { getTimeFilterFromSlug } from '@shared/timeFilter/helpers';

    const BACK_ID = 'back';

    export default {
        mixins: [timeFilterMixing],
        computed: {
            ...mapGetters('ui/sportOffer/sports', [
                'selectedTreeItem',
                'selectedTreeItems',
                'selectedFeaturedItem',
            ]),
            timeFilterId() {
                return this.timeFilter;
            },
            timeFilter() {
                const timeFilterSlug = this.$route.params.timeFilter;
                return timeFilterSlug ? getTimeFilterFromSlug(timeFilterSlug) : TimeFilter.today;
            },
            ...mapGetters('data/sportOffer', [
                'tournaments',
                'categories',
                'sports',
            ]),
            ...mapGetters('data/sportOffer', [
                'featuredItems',
            ]),
            ...mapGetters('ui/mobile', [
                'isSidebarOpen',
            ]),
            selectedItem() {
                let item = {
                    name: this.$t('all'),
                    icon: ['icon--md', 'icon-sport--1000'],
                };
                if (this.$route.query[ExpandedEventInUrl.event]) {
                    item.name = this.$t('back');
                    item.icon = ['icon--md', 'icon-chevron_left'];
                    item.id = BACK_ID;
                    return item;
                }
                if (this.selectedFeaturedItem) {
                    item = this.featuredItems.find(({ id }) => this.selectedFeaturedItem === id);
                    if (item) {
                        item = {
                            name: this.tournaments[item.id].name,
                        };
                    }
                } else {
                    getSportNavItem(this.selectedTreeItem, item, {
                        selectedTreeItems: this.selectedTreeItems,
                        sports: this.sports,
                        tournaments: this.tournaments,
                        categories: this.categories,
                    });
                }
                return item;
            },
            isSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.sportPrimaryNav);
            },
            isTimeFilterExpanded() {
                return this.isSidebarOpen(SidebarId.sportTimeFilter);
            },
        },
        methods: {
            ...mapActions('ui/mobile', [
                'toggleSidebar',
                'closeSidebar',
            ]),
            ...mapActions('ui/sportOffer/sports', [
                'setSelectedTreeItem',
            ]),
            handleClick(selectedItem) {
                if (selectedItem.id === BACK_ID) {
                    const items = [...this.selectedTreeItems];
                    items.pop();
                    this.setSelectedTreeItem(items);
                } else {
                    this.toggleSportsSidebar();
                }
            },
            hideOverlay() {
                this.closeSidebar();
            },
            toggleSportsSidebar() {
                this.toggleSidebar(SidebarId.sportPrimaryNav);
            },
            toggleTimeFilter() {
                this.toggleSidebar(SidebarId.sportTimeFilter);
            },
        },
        components: {
            PrimaryNavItem,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/sportOffer/SportSubNav.vue